import React, {useCallback, useRef, useState} from 'react';
import SectionPopup from './SectionPopup.js';
import PopupSearch from './PopupSearch.js';
import UserCardList from './UserCardList.js';
import usePopupSearch from '../utils/usePopupSearch.js';

// Popup se sekcí Uživatelé (monitoring – ikonka „pozval" otevře kartu toho, kdo
// uživatele pozval). Obsah je stejný jako v sekci /user (sdílená komponenta
// UserCardList), hledání se předvyplní a jde libovolně přepsat.
// onOpenLogs → logy uživatele se otevřou v popupu místo prokliku do /userlog.
export default function UsersPopup({show, close, search: initialSearch = '', name = '', usrInfo, onOpenLogs, onNavigate}) {
	const [loading, setLoading] = useState(false);
	const [info, setInfo] = useState('');
	const listRef = useRef(null);
	const {searchInput, search, onChangeSearch, setSearchNow} = usePopupSearch(show, initialSearch);
	const title = name || initialSearch;

	const handleLoadingChange = useCallback((isLoading) => {
		setLoading(isLoading);
	}, []);

	const toolbar = (
		<>
			<PopupSearch searchValue={searchInput} onChangeSearch={onChangeSearch} placeholder="Vyhledat uživatele" />
			<div className="icon_refresh_main users-popup__refresh" onClick={() => listRef.current?.refresh()} role="button" tabIndex={0} title="Obnovit" aria-label="Obnovit">
				<img className="icon_refresh cr_p" alt="" />
			</div>
			<span className="user-page__summary">
				<span className="user-page__summary-count">{info}</span>
				<img className="icon1 member user-page__summary-icon" alt="" />
			</span>
		</>
	);

	return (
		<SectionPopup show={show} close={close} title={`Uživatelé${title !== '' ? ` – ${title}` : ''}`} toolbar={toolbar} loading={loading} className="users-popup" onNavigate={onNavigate}>
			<div className="user-page user-page--popup">
				<UserCardList ref={listRef} usrInfo={usrInfo} searchValue={search} onChangeSearch={setSearchNow} onLoadingChange={handleLoadingChange} onInfoChange={setInfo} onOpenLogs={onOpenLogs} />
			</div>
		</SectionPopup>
	);
}
